import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
} from "@mui/material";
import { MultiSelect } from "react-multi-select-component";
import React, { useState } from "react";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import CloseIcon from "@mui/icons-material/Close";

function CameraConfiguration({ companyId }) {
  const [allCameraTypes, setAllCameraTypes] = useState([]);
  const [cameraEnabledPages, setCameraEnabledPages] = React.useState([]);
  const [enabledCamera, setEnabledCamera] = React.useState(null);
  const [selectedPage, setSelectedPage] = React.useState(null);
  const [selectedCameraType, setSelectedCameraType] = useState(null);
  const [cameraTypeInputVal, setCameraTypeInputVal] = useState("");
  const getSetCameraEnabledPages = async () => {
    const res = await companyWiseEmp.getCameraEnabledPages(companyId);
    if (res !== null && res.responseCode === 200) {
      setCameraEnabledPages(res.data);
    }
  };

  const getEnabledCameraByPage = async () => {
    const res = await companyWiseEmp.getCameraConfigDataForPage({
      companyId: companyId,
      pageId: selectedPage.id,
    });
    if (res !== null && res.responseCode === 200) {
      setEnabledCamera(res.data);
    } else {
      setEnabledCamera(null);
    }
  };

  const getSetAllCameraTypes = async () => {
    const res = await companyWiseEmp.getCameraTypes();
    if (res !== null && res.responseCode === 200) {
      setAllCameraTypes(res.data);
    } else {
      setAllCameraTypes([]);
    }
  };

  const saveCameraConfigurationForPage = async () => {
    const res = await companyWiseEmp.saveCameraConfig({
      cameraType: selectedCameraType,
      companyId: companyId,
      configPageId: selectedPage.id,
    });
    if (res !== null) {
      alert(
        res.responseDescription || "Camera Configuration Updated Successfully."
      );
      setSelectedCameraType(null);
      setCameraTypeInputVal("");
      getEnabledCameraByPage();
    } else {
      alert("Something Went Wrong.");
    }
  };

  React.useEffect(() => {
    getSetCameraEnabledPages();
  }, [companyId]);

  React.useEffect(() => {
    if (selectedPage) {
      getEnabledCameraByPage();
    } else {
      setEnabledCamera(null);
    }
  }, [selectedPage]);

  React.useEffect(() => {
    getSetAllCameraTypes();
  }, []);

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                Camera Configuration:-
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid container spacing={3}>
              <Grid item>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={cameraEnabledPages}
                    getOptionLabel={(option) => option.pageName}
                    disablePortal={true}
                    fullWidth
                    onChange={(e, newVal) => setSelectedPage(newVal)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select Page"
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={
                      Boolean(selectedPage)
                        ? allCameraTypes.filter(
                            (option) =>
                              option !== enabledCamera?.accessCameraName
                          )
                        : []
                    }
                    value={selectedCameraType}
                    onChange={(e, newVal) => setSelectedCameraType(newVal)}
                    inputValue={cameraTypeInputVal}
                    onInputChange={(e, newVal) => setCameraTypeInputVal(newVal)}
                    disablePortal={true}
                    fullWidth
                    // onChange={(e, newVal) => setSelectedPage(newVal)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Select Camera Type"
                      />
                    )}
                  />
                </div>
              </Grid>

              {Boolean(selectedPage) && Boolean(selectedCameraType) && (
                <Grid item>
                  <div className="field_box">
                    <Button
                      className="field_box_btn1"
                      onClick={saveCameraConfigurationForPage}
                      sx={{
                        cursor: "pointer",
                        color: "#fff",
                        textTransform: "none",
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              )}

              {Boolean(enabledCamera) && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#E0DCD6",
                        p: 1.3,
                        borderRadius: 5,
                      }}
                    >
                      {enabledCamera.accessCameraName}
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
}

export default CameraConfiguration;
